import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const LyricsShadowAngleListItem = (props) => {
    const { shadowSettingsAngle, updateLyricsStyle } = props;
    
    const onShadowAngleChange = (value) => {
        previewHistoryBatch.start();
        
        updateLyricsStyle({ 
            shadowSettings: { angle: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Angle'
            value={shadowSettingsAngle}
            min={0}
            max={360}
            step={1}
            onValueChange={onShadowAngleChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { shadowSettings } = state.createPreview.present.videoSettings.lyrics.style;
    const shadowSettingsAngle = shadowSettings ? (shadowSettings.angle ?? 45) : 45;

    return { shadowSettingsAngle };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsShadowAngleListItem);
